import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const LockOpenIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M10.835 15.624V18l2.326.002v-2.378A2 2 0 0 0 14 13.999a1.999 1.999 0 1 0-3.165 1.625"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 8h1c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h9.1V6c0-1.71-1.39-3.1-3.1-3.1S8.9 4.29 8.9 6H7c0-2.76 2.24-5 5-5s5 2.24 5 5zM6 10v10h12V10z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
